import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default (commonView) =>
  ({ nextStepPath, offerType }) => ({
    ...commonView(nextStepPath),

    paymentMethod: null,
    offer: null,
    internalTracker: new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig
    ),

    init() {
      this.commonInit()

      if (this.store.values.lastPaymentMethod && this.store.values.lastPaymentMethod === "primer") {
        this.store.values.isCardSaved = false
      }

      this.paymentMethod = this.store.values.lastPaymentMethod
      // Retrieve offer by its hardcoded view type
      const offers = pipelineConfig.offers.filter((offer) => offer.type === offerType)
      this.offer = offers[0] // Always return first, as there is only meant 1 offer to be
    },

    handleClick() {
      this.internalTracker.trackClick({ clickName: "Try Again Clicked" })
      
      window.location.href = nextStepPath
    },
  })
